module.exports = __webpack_public_path__ + "img/icon-scissors.bec2f9b3.svg";